// this file used only for frontend testing purposes
// Drupal behaviour placed here adagio/docroot/modules/custom/adagio_banners/js/adagio_information_banner.js

import $ from 'jquery'
$(function() {
  $('.information-banner__wrapper .btn-close').on('click', (e) => {
    e.preventDefault()
    $('.information-banner__wrapper').css('display', 'none')
  })

  function informationOnScroll() {
    const infoBanner =  $('.block-adagiobannersinformationbanner')
    if (infoBanner.length === 0) return
    const header = $('.site-header')
    const headerHeight = header.outerHeight()
    const headerOffsetTop = header[0].offsetTop
    infoBanner.css('top', `${headerHeight + headerOffsetTop}px`)
  }

  $(window).on('scroll', informationOnScroll)
  informationOnScroll()
})


